module.exports = __webpack_public_path__ + "static/liri_bot-062c1fce365dec3cb41490950c4f0ddb.gif";